import { Autocomplete, CircularProgress, Paper } from "@mui/material";
import React, { useEffect } from "react";
import { debounce } from "lodash";
import { axios_api } from "../../../../api/axios-api";
import { OutlinedTextField } from "../../../../Components/formComponents";
import { ISelectOption } from "../../../../constants/types";
import { useAppSelector } from "../../../../redux";

export interface IUserRoleAutoSearchProps {
  value: any;
  onSelect: (value: ISelectOption) => void;
  error?: string;
}


export const UserRoleAutoSearch: React.FC<IUserRoleAutoSearchProps> = (
  props,
) => {
  const { value, onSelect } = props;
  const [loading, setLoading] = React.useState(false);
  const [searchResults, setSearchResults] = React.useState<ISelectOption[]>([]);
  const [searchText, setSearchText] = React.useState("");
  const customizer = useAppSelector(state => state.customizer);

  useEffect(() => {
    fetchSuggestion(value);
  }, []);

  const fetchSuggestion = debounce(async (value) => {
    setLoading(true);
    try {
      const res = await axios_api.get(`/security/get-roles?pageNo=1&itemPerPage=20`);
      const data: any[] = res.data.data;
      const finalData: ISelectOption[] = [];
      for (const role of data) {
        if (role.role_id) {
          finalData.push({
            label: role.role_name,
            value: role.role_uuid,
          });
        }
      }
      setSearchResults(finalData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  }, 500);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value;

    setSearchText(value);
  };
  const getOptionLabel = (option: string | ISelectOption) => {
    if (typeof option === "string") {
      return option;
    }
    return option.label;
  };

  React.useEffect(() => {
    if (value) {
      setSearchText(value);
      fetchSuggestion(value);
    } else {
      setSearchText("");
    }
  }, [value]);

  return (
    <>
      <Autocomplete
        options={searchResults.map((result) => ({
          label: result.label,
          value: result.value,
        }))}
        PaperComponent={({ children }) => (
          <Paper
            style={{
              backgroundColor: customizer.activeMode === "dark" ? "#1E1E1E" : "#ffffff",
              color: customizer.activeMode === "dark" ? "#fff" : "#000",
            }}
          >
            {children}
          </Paper>
        )}
        componentsProps={{
          popper: {
            sx: {
              "& .MuiPaper-root": {
                backgroundColor: customizer.activeMode === "dark" ? "#1E1E1E !important" : "#ffffff !important",
                color: customizer.activeMode === "dark" ? "#fff" : "#000",
              }
            }
          }
        }}
        sx={{
          ".MuiOutlinedInput-root": {
            paddingTop: "2px",
            paddingBottom: "2px",
            fontSize: "0.8rem",
            color: "rgb(38, 38, 38)",
          },
          "& .MuiAutocomplete-paper": {
            backgroundColor: customizer.activeMode === "dark" ? "#1E1E1E" : "#ffffff",
          },
          "& .MuiAutocomplete-listbox": {
            backgroundColor: customizer.activeMode === "dark" ? "#1E1E1E" : "#ffffff",
          }
        }}
        value={searchResults.find((option) => option.value === value) || null}
        defaultValue={value}
        getOptionLabel={getOptionLabel}
        onChange={(e, newValue) => {
          if (newValue && typeof newValue !== "string") {
            onSelect(newValue);
          } else {
            onSelect({ label: "", value: "" });
          }
        }}
        renderInput={(params) => (
          <OutlinedTextField
            {...params}
            label="User Role"
            fullWidth
            value={searchText}
            onChange={handleChange}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading && <CircularProgress color="inherit" size={20} />}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    </>
  );
};
